import base from './base'
import error from './error'

export default {
    ...base,
    ...error,
}
